import React from 'react';
import { Link } from 'react-router';
import { Checkbox, Button, Dialog, label } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemOrganization, RowItemSearchDonViSoNoiVu} from './datatable/list';
import { connect } from 'react-redux';
import { Danhmuc, DuLieuHeThong } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import {Input, TextArea, DropDown, DropDownTreeMultipleSelect} from 'components/tt-forms/common';
import {
  DropDownChonTinhThanh,
  DropDownChonQuanHuyen,
  DropDownChonPhuongXa
} from 'components/tt-forms';
import { InputTuKhoa } from 'modules/reception/form-timkiem';
import {MasterLayout} from 'layout';
import { ShowIf } from 'components/utils';

class Organization extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      idSoBanNganh: '',
      data: [],
      dataSelectDVHC: [],
      dataSelectCCQQL: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      pageDataSNV: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      DataSelectLoaiCoQuanQL:[],
      ThanhPhoId: '',
      QuanHuyenId: '',
      PhuongXaId: '',
      categoryId: 0,
      ma: '',
      ten: '',
      moTa: '',
      maTTCP: '',
      parentCategory: '',
      capCoQuanQuanLyID: '',
      loaiCoQuanQuanLyId: '',
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false,
      isValid: true,
      coQuanQuanLyList: [],
      capCoQuanQuanLyList: [],
      coQuanQuanLyFilter: [],
      capCoQuanQuanLyFilter: [],
      timKiemNangCao: false,
      donViNhanTTXM: false,
      donViThucHienThanhTra: false,
      donViNhanTheoDoiThucHien: false,
      donViTmp: false,
      phongBanTheoDoiThucHien: false,
      donViNhanTTXMCheck: false,
      donViThucHienThanhTraCheck: false,
      donViNhanTheoDoiThucHienCheck: false,
      donViTmpCheck: false,
      phongBanTheoDoiThucHienCheck: false,
      donViSoNoiVu: {},
      showTimKiemDonVi: false,
      listDonViSNV: [],
      loadingSNV: false,
      tuKhoaDonViSNV: '',
      checkButton: '',
      isTTTW: false
    };
  }

  componentDidMount() {
    if (this.props.route.type === "trung-uong") {
      this.getListDataTW();
      this.getCapCoQuanQuanLyTW();
      this.setState({
        isTTTW: true
      });
    } else {
      this.getListData();
      this.getListSelectBoxCCQQL();
      this.setState({
        isTTTW: false
      });
    }
    this.getCapCoQuanQuanLy();
    this.getListLoaiCoQuanQL();
    this.getCoQuanQuanLy();
    this.checkSoBanNganh();
    this.checkSoBanNganhMulti();
    if (window.debug) {
      console.log('category/Organization');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.route.type === "trung-uong") {
      this.getListDataTW();
      this.getCapCoQuanQuanLyTW();
      this.setState({
        isTTTW: true
      });
    } else {
      this.getListData();
      this.getListSelectBoxCCQQL();
      this.setState({
        isTTTW: false
      });
    }
  }

  getListDataTW() {
    this.setState({
      tableLoading: true
    });
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    };
    if (this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getCoQuanTW.request(null, params).then(res => {
      if (res.data._embedded.coQuanQuanLies) {
        const data = res.data._embedded.coQuanQuanLies;
        this.setState({
          data,
          pageData: res.data.page,
          tableLoading: false,
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  getCapCoQuanQuanLyTW() {
    Danhmuc.actions.getCapCoQuanQuanLyTW.request().then(res => {
      if (res.data) {
        this.setState({
          dataSelectCCQQL: [res.data]
        });
      }
    });
  }

  checkSoBanNganhMulti() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let getGiaTri = '';
    let params = {
      tuKhoa : 'CQQL_UBNDTP_DA_NANG,CQQL_THANH_TRA_THANH_PHO'
    }
    DuLieuHeThong.actions.getThamSoHeThong.request(null, params).then(res => {
      if (res && res.data && res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
        getGiaTri = res.data._embedded.thamSoes.findIndex(item => (parseInt(item.giaTri) === userInfo.donViId && item.ten === 'CQQL_UBNDTP_DA_NANG') || (parseInt(item.giaTri) === userInfo.donViId && item.ten === 'CQQL_THANH_TRA_THANH_PHO'));
        this.setState({checkButton: getGiaTri});
      }
    });
  }

  checkSoBanNganh() {
    let params = {
      tuKhoa: 'CCQQL_SO_BAN_NGANH'
    }
    Danhmuc.actions.getThamSo.request(params).then(res => {
      if(res && res.data && res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
        this.setState({idSoBanNganh: res.data._embedded.thamSoes[0].giaTri});
      }
    });
  }

  getCoQuanQuanLy() {
    Danhmuc.actions.getCoQuanQuanLyTimKiem.request().then(res => {
      if (res.data && res.data._embedded) {
        this.setState({coQuanQuanLyList: res.data._embedded.coQuanQuanLies});
      }
    });
  }

  getCapCoQuanQuanLy() {
    Danhmuc.actions.getCapCoQuanQuanLyTimKiem.request().then(res => {
      if (res.data && res.data._embedded) {
        this.setState({capCoQuanQuanLyList: res.data._embedded.capCoQuanQuanLies});
      }
    });
  }

  onChange(name, e) {
    let newState = {...this.state};
    if (name == 'coQuanQuanLyFilter') {
      newState.coQuanQuanLyFilter = e;
    } else if (name == 'capCoQuanQuanLyFilter') {
      newState.capCoQuanQuanLyFilter = e;
    } else {
      newState[name] = e.target.value;
      if (name == 'ThanhPhoId') {
        newState.QuanHuyenId = '';
        newState.PhuongXaId = '';
      } else if (name == 'QuanHuyenId') {
        newState.PhuongXaId = '';
      }
    }
    this.setState({...newState});
  }

  handleSearch(e) {
    e.preventDefault();
    this.setState({
      search: true,
      pageData : {
        number: 0,
        size: 10,
        totalElements: 0
      }
    }, () => {
      if (this.state.isTTTW) {
        this.getListDataTW();
      } else {
        this.getListData(true);
      }
    });
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      donViNhanTTXM: this.state.donViNhanTTXMCheck,
      donViThucHienThanhTra: this.state.donViThucHienThanhTraCheck,
      donViNhanTheoDoiThucHien: this.state.donViNhanTheoDoiThucHienCheck,
      donViTmp: this.state.donViTmpCheck,
      phongBanTheoDoiThucHien: this.state.phongBanTheoDoiThucHienCheck,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    if (this.state.timKiemNangCao) {
      if (this.state.capCoQuanQuanLyFilter.length) {
        let ids = [];
        this.state.capCoQuanQuanLyFilter.map(item => {
          ids.push(item.value);
        });
        params.listCapCoQuanQuanLys = ids.join();
      }
      if (this.state.coQuanQuanLyFilter.length) {
        let ids2 = [];
        this.state.coQuanQuanLyFilter.map(item => {
          ids2.push(item.value);
        });
        params.listCoQuanQuanLys = ids2.join();
      }
    }
    Danhmuc.actions.getCoQuan.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.coQuanQuanLies,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  checkValidate(){
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  getListLoaiCoQuanQL() {
    Danhmuc.actions.getLoaiCoQuanQL.request().then(res => {
       if (res.data._embedded) {
        this.setState({
          DataSelectLoaiCoQuanQL: res.data._embedded.loaiCoQuanQuanLies
        });
      }
    });
  }

  getListSelectBoxDVHC() {
    Danhmuc.actions.getDonViHanhChinh.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataSelectDVHC: res.data._embedded.donViHanhChinhs
        });
      }
    });
  }

  getListSelectBoxCCQQL() {
    Danhmuc.actions.getCapCoQuan.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataSelectCCQQL: res.data._embedded.capCoQuanQuanLies
        });
      }
    });
  }

  createCategory() {
    if(this.checkValidate()) {
      let params = {
        ma: this.state.ma.trim(),
        ten: this.state.ten.trim(),
        moTa: this.state.moTa.trim(),
        maTTCP: this.state.maTTCP.trim(),
        capCoQuanQuanLy: {id: this.state.capCoQuanQuanLyID},
        donViNhanTTXM: this.state.donViNhanTTXM,
        donViThucHienThanhTra: this.state.donViThucHienThanhTra,
        donViNhanTheoDoiThucHien: this.state.donViNhanTheoDoiThucHien,
        donViTmp: this.state.donViTmp,
        phongBanTheoDoiThucHien: this.state.phongBanTheoDoiThucHien
      };
      if (this.state.PhuongXaId) {
        params.donViHanhChinh = {id: this.state.PhuongXaId};
      } else if (this.state.QuanHuyenId) {
        params.donViHanhChinh = {id: this.state.QuanHuyenId};
      } else {
        params.donViHanhChinh = {id: this.state.ThanhPhoId};
      }
      if (this.state.loaiCoQuanQuanLyId) {
        params.loaiCoQuanQuanLy = {id: this.state.loaiCoQuanQuanLyId};
      }
      if (this.state.parentCategory) {
        params.cha = {
          id: this.state.parentCategory.coQuanQuanLyId
        };
      }
      if (this.state.donViSoNoiVu) {
        params.soNoiVuId = this.state.donViSoNoiVu.donViSoNoiVuId;
      }
      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        Danhmuc.actions.updateCoQuan.request({id: this.state.categoryId}, params).then(res => {
          if (this.state.isTTTW) {
            this.getListDataTW();
          } else {
            this.getListData();
          }
          this.toggleDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        Danhmuc.actions.postCoQuan.request('',params).then(res => {
          if (this.state.isTTTW) {
            this.getListDataTW();
          } else {
            this.getListData();
          }
          this.toggleDialog();
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }

  handlePageClick(page) {
    if (this.state.showTimKiemDonVi) {
      this.setState({
        pageDataSNV: {
          ...this.state.pageDataSNV,
          number: page.selected
        }
      }, () => {
        this.timKiemDonViSNV();
      })
    } else {
      this.setState({
        pageData: {
          ...this.state.pageData,
          number: page.selected
        }
      }, () => {
        if (this.state.isTTTW) {
          this.getListDataTW();
        } else {
          this.getListData();
        }
      })
    }
  }

  handleChangePageSize(size) {
    if (this.state.showTimKiemDonVi) {
      this.setState({
        pageDataSNV: {
          ...this.state.pageDataSNV,
          size: size,
          number: 0
        }
      }, () => {
        this.timKiemDonViSNV();
      })
    } else {
      this.setState({
        pageData: {
          ...this.state.pageData,
          size: size,
          number: 0
        }
      }, () => {
        if (this.state.isTTTW) {
          this.getListDataTW();
        } else {
          this.getListData();
        }
      })
    }
  }

  handleDelete(categoryId) {
    if(categoryId){
      this.setState({buttonLoading: true});
      Danhmuc.actions.deleteCoQuan.request({id: categoryId}).then(res => {
        if (this.state.isTTTW) {
          this.getListDataTW();
        } else {
          this.getListData();
        }
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail,'error');
          this.setState({buttonLoading: false});
        }
      });
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  toggleDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {
    this.toggleDialog();
    this.setState({
      addType: 0,
      ma: '',
      ten: '',
      moTa: '',
      maTTCP: '',
      parentCategory: '',
      capCoQuanQuanLyID: '',
      ThanhPhoId: '',
      QuanHuyenId: '',
      PhuongXaId: '',
      donViNhanTTXM: false,
      donViThucHienThanhTra: false,
      donViNhanTheoDoiThucHien: false,
      donViTmp: false,
      phongBanTheoDoiThucHien:false,
      loaiCoQuanQuanLyId: '',
      isValid: true,
      donViSoNoiVu: {}
    });
    this.timKiemDonViSNV();
  }

  openAddMoreCategory(item) {
    this.toggleDialog();
    this.setState({
      addType:1,
      ma: '',
      ten: '',
      parentCategory: item,
      moTa: '',
      maTTCP: '',
      capCoQuanQuanLyID: '',
      ThanhPhoId: '',
      QuanHuyenId: '',
      PhuongXaId: '',
      loaiCoQuanQuanLyId: '',
      isValid: true
    });
    if (item.soNoiVuId) {
      this.state.donViSoNoiVu = {donViSoNoiVuId: item.donViSoNoiVuId, tenDonVi: 'Đã liên kết'};
    } else {
      this.state.donViSoNoiVu = {};
    }
    this.getInfoQuanFromPhuong(item.donViHanhChinhCQQL.donViHanhChinhId);
    this.timKiemDonViSNV();
  }

  openUpdateCategory(item) {
    this.toggleDialog();
    if(item.loaiCoQuanQuanLyInfo != null){
      this.setState({loaiCoQuanQuanLyId: item.loaiCoQuanQuanLyInfo.loaiCoQuanQuanLyId});
    }

    this.setState({
      addType:2,
      ma: item.ma,
      ten: item.ten,
      moTa: item.moTa,
      maTTCP: item.maTTCP || '',
      parentCategory: item.coQuanQuanLyCha,
      capCoQuanQuanLyID: item.capCoQuanQuanLyCQQL.capCoQuanQuanLyId,
      categoryId: item.coQuanQuanLyId,
      QuanHuyenId: '',
      ThanhPhoId: '',
      PhuongXaId: '',
      donViNhanTTXM: item.donViNhanTTXM,
      donViThucHienThanhTra: item.donViThucHienThanhTra,
      donViNhanTheoDoiThucHien: item.donViNhanTheoDoiThucHien,
      donViTmp: item.donViTmp,
      phongBanTheoDoiThucHien: item.phongBanTheoDoiThucHien,
      isValid: true
    });
    if (item.soNoiVuId) {
      this.state.donViSoNoiVu = {donViSoNoiVuId: item.donViSoNoiVuId, tenDonVi: 'Đã liên kết'};
    } else {
      this.state.donViSoNoiVu = {};
    }
    this.timKiemDonViSNV();
    this.getInfoQuanFromPhuong(item.donViHanhChinhCQQL.donViHanhChinhId);
  }
  getInfoQuanFromPhuong(ItemID){
    Danhmuc.actions.getInfoDonViHanhChinh.request({id: ItemID}).then(res => {
      if(res.data){
        if (res.data.donViHanhChinhCha == null) {
          this.setState({
            ThanhPhoId: ItemID,
            QuanHuyenId: ''
          });
        } else {
          this.getInfoThanhPhoFromQuan(res.data.donViHanhChinhCha.donViHanhChinhId, ItemID);
          this.setState({QuanHuyenId: res.data.donViHanhChinhCha.donViHanhChinhId});
        }
      }
    });
  }
  getInfoThanhPhoFromQuan(ParentsId, ChildrenId){
    Danhmuc.actions.getInfoDonViHanhChinh.request({id: ParentsId}).then(res => {
      if(res.data){
        if (res.data.donViHanhChinhCha == null) {
          this.setState({
            ThanhPhoId: ParentsId,
            QuanHuyenId: ChildrenId,
            PhuongXaId: ''
          });
        } else {
          this.setState({
            ThanhPhoId: res.data.donViHanhChinhCha.donViHanhChinhId,
            QuanHuyenId: ParentsId,
            PhuongXaId: ChildrenId
          });
        }
      }
    });
  }

  toggleSearch(status) {
    if (status) {
      this.setState({timKiemNangCao : true});
    } else {
      this.setState({timKiemNangCao : false});
    }
  }

  changeCheckbox(e) {
    this.setState({[e.target.name]: e.target.checked});
  }

  setValue(name, value) {
    this.setState({[name]: value});
  }
  timKiemDonViSNV() {
    let params = {
      page: this.state.pageDataSNV.number,
      size: this.state.pageDataSNV.size,
      tuKhoa: this.state.tuKhoaDonViSNV.trim()
    }
    this.setState({loadingSNV: true});
    Danhmuc.actions.getDonViSoNoiVu.request(null, params).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({
          listDonViSNV: res.data._embedded.donViSoNoiVus,
          pageDataSNV: res.data.page
        });
      } else {
        this.setState({listDonViSNV: [],
          pageDataSNV: {
            number: 0,
            size: 10,
            totalElements: 0
          }
        })
      }
      this.setState({loadingSNV: false});
    }).catch(e => {
      this.setState({loadingSNV: false});
    });
  }

  handleSelectSNV(item) {
    this.state.donViSoNoiVu = item;
    this.setValue('showTimKiemDonVi', false);
  }
  render() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const dataCheckbox = [
      {
        name: 'donViNhanTTXMCheck',
        checked: this.state.donViNhanTTXMCheck ? true : false,
        text: 'Đơn vị nhận thẩm tra xác minh'
      },
      {
        name: 'donViNhanTheoDoiThucHienCheck',
        checked: this.state.donViNhanTheoDoiThucHienCheck ? true : false,
        text: 'Đơn vị nhận theo dõi thực hiện'
      },
      {
        name: 'donViTmpCheck',
        checked: this.state.donViTmpCheck ? true : false,
        text: 'Đơn vị nhận TTXM-KNPA'
      },
      {
        name: 'phongBanTheoDoiThucHienCheck',
        checked: this.state.phongBanTheoDoiThucHienCheck ? true : false,
        text: 'Phòng ban nhận theo dõi thực hiện'
      },
      {
        name: 'donViThucHienThanhTraCheck',
        checked: this.state.donViThucHienThanhTraCheck ? true : false,
        text: 'Đơn vị thực hiện thanh tra'
      }
    ];
    return (
      <MasterLayout routerName={this.props.route.name}>
      <div className="center reception-container">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-reception"></i> {this.state.isTTTW ? 'Danh sách cơ quan thanh tra trung ương tại Tỉnh' : 'Cơ quan quản lý'}</p>
          </div>
          <div className="right-content">
            {
              // CheckPermission('COQUANQUANLY_THEM') && this.state.checkButton !== -1 ?
              CheckPermission('COQUANQUANLY_THEM') ?
                <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
              : null
            }
          </div>
        </div>
        <div className="bottom-content">
          <div className={ this.state.timKiemNangCao ? 'search-container super-search' : 'search-container' }>
            <form className="search-form" onSubmit={ this.handleSearch.bind(this) }>
              <InputTuKhoa value={this.state.tuKhoa} onChange={ this.onChange.bind(this, 'tuKhoa') } placeholderText="Nhập từ khóa để tìm kiếm..." />
              <div className="btn-wrap">
                <Button className={`btn-green tt-search`} text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
              </div>
              {
                this.state.timKiemNangCao &&
                  <div className="btn-wrap">
                    <Link style={{marginTop: '10px'}} className={ this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search" } onClick={ this.toggleSearch.bind(this, false) }><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
                  </div>
              }
              {
                this.state.timKiemNangCao &&
                  <div className='clear-left'>
                    <DropDownTreeMultipleSelect className="tree-selected" label="Cấp cơ quan quản lý" dataOptions={this.state.capCoQuanQuanLyList} dataSelected={this.state.capCoQuanQuanLyFilter} onChange={this.onChange.bind(this, 'capCoQuanQuanLyFilter')} selectAllChildren={false} propertyChildren='capCoQuanQuanLyCha' propertyParent='capCoQuanQuanLyId'/>
                    <DropDownTreeMultipleSelect className="tree-selected" label="Cơ quan quản lý" dataOptions={this.state.coQuanQuanLyList} dataSelected={this.state.coQuanQuanLyFilter} onChange={this.onChange.bind(this, 'coQuanQuanLyFilter')} selectAllChildren={false} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId'/>
                    <ShowIf condition={userInfo.id === 1}>
                    {
                      dataCheckbox && dataCheckbox.map((item,index) => (
                        <Checkbox key={index} className="pt-position-button tree-selected pt-large" name={item.name} checked={item.checked} onChange={this.changeCheckbox.bind(this)}>
                         <span className="span-checkbox span-position-label">{item.text}</span>
                       </Checkbox>
                     ))
                    }
                    </ShowIf>
                  </div>
              }
            </form>
            { !this.state.isTTTW &&
              <Link className="rearch-text" onClick={ this.toggleSearch.bind(this, true) }><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            }
          </div>
          <DataTable
            header={this.state.isTTTW ? header.categoryGroup.coquanthanhtratw : header.categoryGroup.organization}
            dataList={this.state.data}
            pageData={this.state.pageData}
            hideExport
            parent={this}
            tableLoading = {this.state.tableLoading}>
            <RowItemOrganization isTTTW={this.state.isTTTW} />
          </DataTable>
        </div>
        <Dialog
          isOpen={this.state.popupAddCategory}
          onClose={this.toggleDialog.bind(this)}
          title={this.state.addType == 2 ? 'Chỉnh sửa cơ quan quản lý' : 'Thêm mới cơ quan quản lý'}
          iconName="add-new"
          className="panel-popup category organization-content">
          { !this.state.showTimKiemDonVi &&
            <div className="pt-dialog-body">
              <Input className="col-6" label="Mã" value={this.state.ma} require={true} onChange={this.onChange.bind(this, 'ma')} bindValidator={this} channel="danhMuc"/>
              { !this.state.isTTTW &&
                <Input className="col-6" label="Mã TTCP" value={this.state.maTTCP} require={false} maxLength={40} onChange={this.onChange.bind(this, 'maTTCP')} channel="danhMuc"/>
              }
              <Input className="col-6" label="Tên" value={this.state.ten} require={true} onChange={this.onChange.bind(this, 'ten')} bindValidator={this} channel="danhMuc"/>
              { !this.state.isTTTW &&
                <DropDown className="col-6" label="Loại cơ quan quản lý" options={this.state.DataSelectLoaiCoQuanQL} keyName="loaiCoQuanQuanLyId" valueName="ten"
                selectedValue={this.state.loaiCoQuanQuanLyId} placeholder={{key:'', text: 'Chọn...'}} onChange={this.onChange.bind(this, 'loaiCoQuanQuanLyId')}/>
              }
              <DropDown className="col-6" label="Cấp cơ quan quản lý" require={true} options={this.state.dataSelectCCQQL} keyName="capCoQuanQuanLyId" valueName="ten"
                selectedValue={this.state.capCoQuanQuanLyID} placeholder={{key:'', text: 'Chọn...'}} onChange={this.onChange.bind(this, 'capCoQuanQuanLyID')} bindValidator={this} channel="danhMuc"/>
              {/* Ẩn chọn liên kết sở nội vụ  */}
              {/* { !this.state.isTTTW &&
                <div className='col-12 mb18'>
                  <label className="ip-label">Liên kết Đơn vị Sở nội vụ</label>
                  { this.state.donViSoNoiVu ? <label className="val-content pr15" style={{display: 'inline-block'}}>{this.state.donViSoNoiVu.tenDonVi}</label> : ''}
                  <Link className="btn-green" onClick={this.setValue.bind(this, 'showTimKiemDonVi', true)} >
                    <span>Chọn Đơn vị</span>
                  </Link>
                </div>
              } */}
              { !this.state.isTTTW &&
              <div className="col-12">
                {this.state.parentCategory ? (
                  <label className="pt-label">
                   Đơn vị hành chính cha: {this.state.parentCategory.ten}
                  </label>
                ) : null}
              </div>
              }
              { !this.state.isTTTW &&
              <div className="col-12">
                <label className="pt-label">
                  ĐƠN VỊ HÀNH CHÍNH
                </label>
              </div>
              }
              <div className="col-12 mlr-5">
                <DropDownChonTinhThanh className="col-4" require={true} selectedValue={this.state.ThanhPhoId}
                onChange={this.onChange.bind(this, 'ThanhPhoId')} bindValidator={this}/>
                <DropDownChonQuanHuyen className="col-4" selectedValue={this.state.QuanHuyenId}
                thanhPhoID={this.state.ThanhPhoId}  onChange={this.onChange.bind(this, 'QuanHuyenId')}/>
                <DropDownChonPhuongXa className="col-4" selectedValue={this.state.PhuongXaId}
                quanHuyenId={this.state.QuanHuyenId} onChange={this.onChange.bind(this, 'PhuongXaId')}
                thanhPhoID={this.state.ThanhPhoId} />
              </div>
              <ShowIf condition={!this.state.isTTTW && userInfo.id === 1}>
                {/* <div className="col-100 mb5" >
                  <input type="checkbox" id="dvnTTXM" className="input-cb" name="donViNhanTTXM" checked={this.state.donViNhanTTXM} value={this.state.donViNhanTTXM} onChange={this.changeCheckbox.bind(this)}/>
                  <label htmlFor="dvnTTXM">Đơn vị nhận thẩm tra xác minh</label>
                </div>
                <div className="col-100 mb5" >
                  <input type="checkbox" id="dvnTDTT" className="input-cb" name="donViNhanTheoDoiThucHien" checked={this.state.donViNhanTheoDoiThucHien} value={this.state.donViNhanTheoDoiThucHien} onChange={this.changeCheckbox.bind(this)}/>
                  <label htmlFor="dvnTDTT">Đơn vị nhận theo dõi thực hiện</label>
                </div>
                <div className="col-100 mb5" >
                  <input type="checkbox" id="dvnTTXMKNPA" className="input-cb" name="donViTmp" value={this.state.donViTmp} checked={this.state.donViTmp} onChange={this.changeCheckbox.bind(this)}/>
                  <label htmlFor="dvnTTXMKNPA">Đơn vị nhận TTXM-KNPA</label>
                </div>
                <div className="col-100 mb5" >
                  <input type="checkbox" id="phongBanTheoDoiThucHien" className="input-cb" name="phongBanTheoDoiThucHien" value={this.state.phongBanTheoDoiThucHien} checked={this.state.phongBanTheoDoiThucHien} onChange={this.changeCheckbox.bind(this)}/>
                  <label htmlFor="phongBanTheoDoiThucHien">Phòng ban nhận theo dõi thực hiện</label>
                </div> */}
                <div className="col-100 mb5" >
                  <input type="checkbox" id="dvTHTT" className="input-cb" name="donViThucHienThanhTra" checked={this.state.donViThucHienThanhTra} value={this.state.donViThucHienThanhTra} onChange={this.changeCheckbox.bind(this)}/>
                  <label htmlFor="dvTHTT">Đơn vị thực hiện thanh tra</label>
                </div>
              </ShowIf>
              <TextArea label="Mô tả" maxLength={255} rows={5} value={this.state.moTa} onChange={this.onChange.bind(this, 'moTa')} className='col-12'/>
            </div>
          }
          { !this.state.showTimKiemDonVi &&
            <div className="pt-dialog-footer">
              <Link onClick={this.toggleDialog.bind(this)} className="btn-action btn-close" >
                <span>Đóng</span>
              </Link>
              <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
              </Link>
            </div>
          }
          { this.state.showTimKiemDonVi &&
            <div className="pt-dialog-body">
              <div className="back-foward mt0">
                <Link onClick={this.setValue.bind(this, 'showTimKiemDonVi', false)}>Về trang trước</Link>
              </div>
              <div id="list-people-search" className="search-name-container">
                <form className="items-form" onSubmit={this.timKiemDonViSNV.bind(this)} action="javascript:void(0)">
                  <div className="rows">
                    <Input label="Từ khóa" className="col-80" value={this.state.tuKhoaDonViSNV} onChange={this.onChange.bind(this, 'tuKhoaDonViSNV')}/>
                    <div className="col-2">
                      <label className="seacrh-people">
                        <Button type="submit" className="btn-search" text="Tìm kiếm"/>
                      </label>
                    </div>
                  </div>
                </form>
                <DataTable
                  header={header.popUpDonViSNV}
                  dataList={this.state.listDonViSNV}
                  hideButtonExport={true}
                  pageData={this.state.pageDataSNV}
                  parent={this}
                  tableLoading={this.state.loadingSNV}>
                  <RowItemSearchDonViSoNoiVu onSelect={this.handleSelectSNV.bind(this)}/>
                </DataTable>
              </div>
            </div>
          }
        </Dialog>
      </div>
      </MasterLayout>
    );
  }
}
Organization.defaultProps = {
  validators: {}
}
function bindStateToProps(state) {
  return {};
}

export default connect(bindStateToProps)(Organization);



// WEBPACK FOOTER //
// ./src/components/modules/category/Organization.jsx